export default __webpack_public_path__ + "static/media/c10e46419ee5a6051bd7a4a6d7a64235.jpg";